import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";

const NormalInput = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-input": {
    // height: "22.5px",
    // padding: "10px",
    fontSize: "16px",
    color: "#333",
    fontWeight: "300",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
  },
}));

const DisabledInput = styled(NormalInput)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    backgroundColor: "#F5F5F5",
  },
}));

const MuiInput = (props) => {
  const {
    key,
    label,
    value,
    onChange,
    readOnly,
    type = "text",
    error,
    helperText,
    rows,
    multiline,
    sx,
    maxLength = 500,
    slotProps,
    placeholder,
    InputProps
  } = props;

  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value);
  }, [value]);

  const handleChange = (e) => {
    setText(e.target.value);
  };

  return (
    <>
      {!readOnly && (
        <NormalInput
          fullWidth
          size="small"
          key={key}
          label={label}
          // defaultValue={value}
          value={text}
          onBlur={() => onChange(text)}
          onChange={handleChange}
          disabled={false}
          type={type}
          rows={rows}
          multiline={multiline}
          error={error}
          sx={{ ...sx }}
          // slot={slotProps}
          inputProps={{ maxLength: maxLength }}
          onKeyDown={(event) => {
            event.stopPropagation();
          }}
          placeholder={placeholder}
          slotProps={slotProps}
          InputProps={InputProps}

        />
      )}

      {readOnly && (
        <DisabledInput

          fullWidth
          size="small"
          key={key}
          label={label}
          defaultValue={value}
          value={value}
          onBlur={() => onChange(text)}
          onChange={handleChange}
          disabled={true}
          type={type}
          rows={rows}
          multiline={multiline}
          error={error}
          sx={{ ...sx }}
          // slot={slotProps}
          slotProps={slotProps}
          InputProps={InputProps}

        />
      )}
      {error && helperText && (
        <Typography
          color="error"
          fontWeight={600}
          variant="caption"
          sx={{
            mt: 0.5,
            ml: 1,
            display: "block",
          }}
        >
          {helperText}
        </Typography>
      )}
    </>
  );
};

export default MuiInput;
